enum DriverPermissions {
  CREATE_DRIVER = 'CREATE_DRIVER',
  UPDATE_DRIVER = 'UPDATE_DRIVER',
  DELETE_DRIVER = 'DELETE_DRIVER',
  READ_DRIVER = 'READ_DRIVER'
}

export default DriverPermissions;